import { render } from "./StaticHome.vue?vue&type=template&id=3080d359&scoped=true"
import script from "./StaticHome.vue?vue&type=script&lang=js"
export * from "./StaticHome.vue?vue&type=script&lang=js"

import "./StaticHome.vue?vue&type=style&index=0&id=3080d359&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080d359"]])

export default __exports__